import { AstActionItem } from '@ps/bridge/qc/scripts/editor'
import { VpMaskMethods } from '@ps/bridge/qc/vp/mask'
import {
  i18nMaskGroup,
  i18nMaskSubGroup,
} from '@ps/workbench/undo-redo/module/mask'
// 响应动作参数国际化翻译
export function i18nParamParse(action: AstActionItem, text: string): string {
  let res = text
  if (
    action.method === VpMaskMethods.vpEnableMaskGroupComponent ||
    action.method === VpMaskMethods.vpShowMaskGroup ||
    action.method === VpMaskMethods.vpEnableMaskShape
  ) {
    res = i18nMaskGroup(text)
  } else if (action.method === VpMaskMethods.vpShowMaskSubGroup) {
    res = i18nMaskSubGroup(text)
  }
  return res
}
// 响应动作参数国际化翻译
export function i18nParamTransform(method: string, key: string, uiSchema) {
  if (
    key === 'actionGroup' &&
    (method === VpMaskMethods.vpEnableMaskGroupComponent ||
      method === VpMaskMethods.vpShowMaskGroup ||
      method === VpMaskMethods.vpEnableMaskShape)
  ) {
    uiSchema[key].field.options.forEach((item) => {
      item.label = i18nMaskGroup(item.value)
    })
  } else if (
    key === 'actionGroup' &&
    method === VpMaskMethods.vpShowMaskSubGroup
  ) {
    uiSchema[key].field.options.forEach((item) => {
      item.label = i18nMaskSubGroup(item.value)
    })
  }
}
